import { Box, Typography, Stack, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import * as React from "react";
import { Outlet } from "react-router-dom";
import useResponsive from "../../hooks/useResponsive";

const AuthLayout: React.FC = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xs");
  const isSmall = useResponsive("down", "sm", "xs");

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: theme.palette.common.white,
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          width: isSmall ? '95%' : isMedium ? "80%" : "48%",
          marginX: "auto",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            width: isSmall ? '100%' : "75%",
            marginX: "auto",
          }}
        >
          <Box
            sx={{
              paddingY: "3rem",
              margin: 3,
              display: "flex",
              justifyContent: isMedium ? "center" : "flex-start",
            }}
          >
            <img
              src="/assets/icons/logo-img.svg"
              width="220px"
              height={"30px"}
              alt=""
            />
          </Box>
          <Outlet />
        </Box>
      </Box>
      <IconBg />
    </Box>
  );
};
export default AuthLayout;

const IconBg = () => {
  const isMedium = useResponsive("down", "md", "xs");
const theme = useTheme()
  return (
    <Box
      sx={{
        display: isMedium ? "none" : "block",
        width: isMedium ? "0px" : "52%",
        height: "96vh",
        marginY: "auto",
        marginX: 3,
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          right: 30,
          zIndex: 10,
          width: 200,
        }}
      >
        <img src="/assets/icons/logo-text.svg" alt="" width={"94%"} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          width: "95%",
          height: "100%",
          backgroundColor: theme.palette.primary.light,
          zIndex: 5,
          borderRadius: "20px",
        }}
      ></Box>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          width: "78%",
          height: "100%",
          opacity: 0.34,
          borderRadius: "20px",
          position: "absolute",
          right: 0,
          zIndex: 5,
        }}
      />
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          width: "55%",
          height: "100%",
          opacity: 0.7,
          borderRadius: "20px",
          position: "absolute",
          right: 0,
          zIndex: 5,
        }}
      />
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          width: "32%",
          height: "100%",
          borderRadius: "20px",
          position: "absolute",
          right: 0,
          zIndex: 5,
        }}
      />
    </Box>
  );
};
